import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getNewbuildingLink = (state: IState) => {
  return (
    pathOr('', ['offerData', 'newObject', 'fullUrlWithSubdomain'], state) ||
    pathOr('', ['offerData', 'newObject', 'url'], state)
  );
};
